import React, { FC, memo } from 'react';

import * as Yup from 'yup';

import { ConfirmButton, RequestErrorMessage } from 'src/components';
import styles from './WorkspaceFields.module.scss';
import isEmpty from 'lodash/isEmpty';
import { Form, Formik } from 'formik';
import { TFieldOption, TRadioFields, TUserAccessForm, TWorkspaceNameForm } from 'src/interfaces/WorkspacesTypes';
import CustomRadioGroup from './CustomRadioGroup';
import TextInput from './TextInput';

type TWorkspaceFieldsProps = {
  initialValues: TWorkspaceNameForm | TUserAccessForm;
  fileds: TFieldOption[];
  schema:
    | Yup.ObjectSchema<TWorkspaceNameForm, Record<string, string>>
    | Yup.ObjectSchema<TUserAccessForm, Record<string, string>>;
  onSubmit: (values) => void;
  actionBtn?: (param: { isDisabled?: boolean }) => React.ReactNode;
  requestError?: { message?: string } | null;
  size?: 'sm' | 'md';
  radioBtns?: TRadioFields;
};

const WorkspaceFields: FC<TWorkspaceFieldsProps> = memo(
  ({ requestError, actionBtn, onSubmit, size = 'md', initialValues, schema, fileds, radioBtns }) => {
    return (
      <Formik initialValues={initialValues} validationSchema={schema} onSubmit={onSubmit}>
        {({ values, errors }) => {
          const isSomeValuesFalsy = Object.keys(values).some((key) => !values[key]);
          const hasErrors = isSomeValuesFalsy || !isEmpty(errors);

          return (
            <Form className={styles.form}>
              <>
                <div className={styles.fieldsWrapper}>
                  <TextInput size={size} fileds={fileds} />
                </div>

                {!!radioBtns && <CustomRadioGroup name={radioBtns.name} options={radioBtns.options} />}

                <div className={styles.controlsBlock}>
                  {requestError && (
                    <RequestErrorMessage
                      customClass={styles.requestErrorMsg}
                      msg={requestError?.message ?? 'Something went wrong... Please try again.'}
                    />
                  )}

                  {actionBtn ? (
                    actionBtn({ isDisabled: hasErrors })
                  ) : (
                    <ConfirmButton type="submit" isDisabled={hasErrors} btnClass={styles.submitBtn}>
                      Create
                    </ConfirmButton>
                  )}
                </div>
              </>
            </Form>
          );
        }}
      </Formik>
    );
  }
);

WorkspaceFields.displayName = 'WorkspaceFields';

export default WorkspaceFields;
